import "./Acquisition.css";
import FAQ from "./FAQ";
import { fetchAcquisitionFaq, fetchFundraiseProgress } from "../api/strapi";
import { useState, useEffect } from "react";
import { useTranslation, Trans } from "react-i18next";
import { Link, Mail } from "react-feather";

function Acquisition() {
  const { t, i18n } = useTranslation();
  const [faqs, setFaqs] = useState([]);
  const [progress, setProgress] = useState(null);
  const [donateOpen, setDonateOpen] = useState(false);
  const [loanOpen, setLoanOpen] = useState(false);
  const [wgOpen, setWgOpen] = useState(false);
  const [organiseOpen, setOrganiseOpen] = useState(false);

  const toggleDonate = () => {
    setDonateOpen(!donateOpen);
  };

  const toggleLoan = () => {
    setLoanOpen(!loanOpen);
  };

  const toggleWg = () => {
    setWgOpen(!wgOpen);
  };

  const toggleOrganise = () => {
    setOrganiseOpen(!organiseOpen);
  };

  useEffect(() => {
    fetchAcquisitionFaq(i18n.language)
      .then((data) => {
        setFaqs(data.FAQ);
      })
      .catch((_) => {
        setFaqs([]);
      });

    setProgress({
      mortgagePercentage: (1 / 1.7) * 100,
      donationPercentage: (0.18 / 1.7) * 100,
      loanPercentage: (0.52 / 1.7) * 100,
      totalAcquisitionCost: 17000000,
    });
  }, [i18n.language]);

  return (
    <>
      <div className="w-full p-2 bg-stone-500 bg-opacity-70 mt-8">
        <div class="relative mx-5 my-4">
          <div class="mb-2 flex h-8 overflow-hidden rounded bg-gray-100 text-s shim-blue">
            <div
              style={{
                width: (progress && progress.donationPercentage + "%") || 0,
              }}
              class="pl-2 bg-green-500 transition-all duration-500 ease-out font-bold"
            >
              DONATIONS
            </div>
            <div
              style={{
                width: (progress && progress.loanPercentage + "%") || 0,
              }}
              class="pl-2 bg-yellow-500 transition-all duration-500 ease-out font-bold"
            >
              LOANS
            </div>
            <div
              style={{
                width: (progress && progress.mortgagePercentage + "%") || 0,
              }}
              class="pl-2 bg-red-500 transition-all duration-500 ease-out font-bold"
            >
              MORTGAGE
            </div>
          </div>
          <div class=" flex items-center font-semibold justify-between text-2xl text-black">
            <div>0€</div>
            <div>{progress && progress.totalAcquisitionCost + "€"}</div>
          </div>
        </div>
        <h3 className="text-5xl py-2 font-bold text-center italic">
          <Trans i18nKey="acquisition.finished.title">
          HEY HELLO WERE ALMOST DONE
          </Trans>
        </h3>

        <p className="py-2 text-2xl text-center w-full align-middle  whitespace-pre-line ">
          <Trans i18nKey="acquisition.finished.desc">
          <a href="https://radar.squat.net/en/event/nijmegen/de-klinker/2026-06-05/were-buying-de-broek-festival"></a>
          </Trans>
          <iframe
            width="560"
            height="315"
            className=" block m-auto mt-4"
            src="https://www.youtube.com/embed/wrE9jGBcwR0?enablejsapi=1&controls=1&autoplay=1&mute=1&modestbranding=1"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
          ></iframe>
        </p>
      </div>


      <div className="my-4">
        <div className="hazard-background"></div>
        <div className="w-full bg-yellow-400 p-2">
          <h3 className="text-2xl py-2 font-bold text-center">FAQ</h3>
          <dl>
            {faqs.map((faq, index) => (
              <FAQ faq={faq} key={index} />
            ))}
          </dl>
        </div>
      </div>
    </>
  );
}

export default Acquisition;
